import React from 'react';

export interface ModalProps {
  isOpen: boolean;
  title?: string;
  children?: React.ReactNode;
  onClose: () => void;
  actionLabel?: string;
  onAction?: () => void;
  actionDisabled?: boolean;
  className?: string;
  isDanger?: boolean;
  closeLabel?: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, title, children, onClose, actionLabel, onAction, actionDisabled, className, isDanger = false, closeLabel = 'Close' }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <div className={`modal ${className || ''}`}>
        <button className="modal__close" aria-label="Close" onClick={onClose}><span className="material-symbols-outlined">close</span></button>
        {title && <h2 id="modal-title" className="modal__title">{title}</h2>}
        <div className="modal__content">
          {children}
        </div>
        {(actionLabel || onAction) && (
          <div className="modal__actions">
            <button className="btn btn-secondary" onClick={onClose}>{closeLabel}</button>
            {actionLabel && (
              <button 
                className={`btn ${isDanger ? 'btn--danger' : 'btn-primary'}`} 
                onClick={onAction || onClose}
                disabled={actionDisabled}
              >
                {actionLabel}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;

